module.exports = __webpack_public_path__ + "b4262644824a028810ca42e7d45fe161.svg";